import { render, staticRenderFns } from "./CustomersHeaderClassic.vue?vue&type=template&id=64ece29c&"
import script from "./CustomersHeaderClassic.vue?vue&type=script&lang=ts&"
export * from "./CustomersHeaderClassic.vue?vue&type=script&lang=ts&"
import style0 from "./CustomersHeaderClassic.vue?vue&type=style&index=0&id=64ece29c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports